import { InfoCircleTwoTone } from "@ant-design/icons";
import { Checkbox, Form, Tooltip } from "antd";
import SchemaClassifiersFieldProperty from "components/atoms/SchemaClassifiersFieldProperty";
import SchemaMaxLengthFieldProperty from "components/atoms/SchemaMaxLengthFieldProperty";
import SchemaMinLengthFieldProperty from "components/atoms/SchemaMinLengthFieldProperty";
import Segment from "components/atoms/Segment";
import CypressTestIds from "../../../cypress/CypressTestIds";

const UrlFieldProperties = ({ formRef, selectedFieldRow, readOnly, dataType, getFormErrors }) => {
    return (
        <>
            <Segment.Group>
                <Segment className="form-background">
                    <SchemaMinLengthFieldProperty
                        selectedFieldRow={selectedFieldRow}
                        readOnly={readOnly}
                        dataType={dataType}
                        getFormErrors={getFormErrors}
                    ></SchemaMinLengthFieldProperty>
                </Segment>
                <Segment className="form-background">
                    <SchemaMaxLengthFieldProperty
                        selectedFieldRow={selectedFieldRow}
                        readOnly={readOnly}
                        dataType={dataType}
                        getFormErrors={getFormErrors}
                    ></SchemaMaxLengthFieldProperty>
                </Segment>
                <Segment className="form-background">
                    <SchemaClassifiersFieldProperty selectedFieldRow={selectedFieldRow} readOnly={readOnly} getFormErrors={getFormErrors}></SchemaClassifiersFieldProperty>
                </Segment>
                <Segment className="form-background">
                    <Form.Item label="Multi Value" name={["fields", selectedFieldRow.name, "isMultivalue"]} valuePropName="checked" initialValue={false}>
                        <Checkbox disabled={readOnly} data-testid={CypressTestIds.SCHEMA_MULTIVALUE_PROPERTY_CHECKBOX}></Checkbox>
                    </Form.Item>
                </Segment>
                <Segment className="form-background">
                    <Form.Item label="PII" name={["fields", selectedFieldRow.name, "isPII"]} valuePropName="checked" initialValue={false}>
                        <Checkbox disabled={readOnly} data-testid={CypressTestIds.SCHEMA_PII_PROPERTY_CHECKBOX}>
                            <Tooltip title="Flag this field as Personally Identifiable Information or Sensitive Data">
                                <InfoCircleTwoTone />
                            </Tooltip>
                        </Checkbox>
                    </Form.Item>
                </Segment>
            </Segment.Group>
        </>
    );
};

export default UrlFieldProperties;
